import styled from 'styled-components';

export const LinkedinSVG = styled.svg`
  ${({ theme }) => theme.mediaQuery.lg} {
    width: 3rem;
    height: 3rem;
  }
`;
